"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SbsPrimaryContainerMultipleRows = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Button = require("../../../../base-components/Button/Button");
var _Typography = require("../../../../base-components/Typography/Typography");
var _PropertyProvider = require("../../../../utils/PropertyProvider/PropertyProvider");
var _SbsSecondaryContainerMultipleRows = require("./SbsSecondaryContainerMultipleRows");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SbsPrimaryContainerMultipleRows = exports.SbsPrimaryContainerMultipleRows = function SbsPrimaryContainerMultipleRows(_ref) {
  var styles = _ref.styles,
    image = _ref.image,
    gridProps = _ref.gridProps,
    primaryButtonProps = _ref.primaryButtonProps,
    secondaryButtonProps = _ref.secondaryButtonProps,
    textComponents = _ref.textComponents,
    textComponentsProps = _ref.textComponentsProps,
    textComponentsStyles = _ref.textComponentsStyles,
    namespace = _ref.namespace;
  return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.imageWrapper
  }, /*#__PURE__*/_react["default"].createElement("img", {
    src: image.src,
    alt: image.alt,
    className: styles.image
  })), /*#__PURE__*/_react["default"].createElement(_SbsSecondaryContainerMultipleRows.SbsSecondaryContainerMultipleRows, _extends({}, gridProps, {
    TitleComponent: "div"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.buttonsContainer
  }, !!primaryButtonProps && primaryButtonProps.children && /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, primaryButtonProps, {
    namespace: (0, _PropertyProvider.NS)(namespace, 'primary')
  })), !!secondaryButtonProps && secondaryButtonProps.children && /*#__PURE__*/_react["default"].createElement(_Button.Button, _extends({}, secondaryButtonProps, {
    namespace: (0, _PropertyProvider.NS)(namespace, 'secondary')
  }))), /*#__PURE__*/_react["default"].createElement(_Typography.Typography, {
    components: textComponents,
    styles: textComponentsStyles,
    componentProps: textComponentsProps
  }));
};
SbsPrimaryContainerMultipleRows.propTypes = {
  styles: _propTypes["default"].shape({
    imageWrapper: _propTypes["default"].string,
    image: _propTypes["default"].string
  }),
  image: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  }),
  gridProps: _propTypes["default"].shape({}),
  primaryButtonProps: _propTypes["default"].shape(Object.assign({}, _Button.Button.propTypes, {
    children: _propTypes["default"].node
  })),
  secondaryButtonProps: _propTypes["default"].shape(Object.assign({}, _Button.Button.propTypes, {
    children: _propTypes["default"].node
  })),
  textComponents: _propTypes["default"].shape({}),
  textComponentsProps: _propTypes["default"].shape({}),
  textComponentsStyles: _propTypes["default"].shape({}),
  namespace: _propTypes["default"].string
};
SbsPrimaryContainerMultipleRows.defaultProps = {
  primaryButtonProps: _Button.Button.defaultProps,
  secondaryButtonProps: _Button.Button.defaultProps,
  textComponents: {},
  textComponentsProps: {},
  textComponentsStyles: {},
  styles: {},
  image: {
    src: '',
    alt: ''
  },
  gridProps: {},
  namespace: ''
};